export const MEDIA_UPLOAD_STATE_IDLE = 0;
export const MEDIA_UPLOAD_STATE_UPLOADING = 1;
export const MEDIA_UPLOAD_STATE_SUCCEEDED = 2;
export const MEDIA_UPLOAD_STATE_FAILED = 3;
export const MEDIA_UPLOAD_STATE_RESET = 4;
export const MEDIA_UPLOAD_STATE_PAUSED = 11;
